import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

//router
import { BrowserRouter } from 'react-router-dom';
//store

import { Provider } from 'react-redux';
//reducer
import Store from './store';
import { RecoilRoot } from 'recoil';

const container = document.getElementById('root');
const ReactRoot = createRoot(container); // createRoot(container!) if you use TypeScript
ReactRoot.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <Provider store={Store}>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </Provider>
  </BrowserRouter>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
